import { usersQuery } from './usersQuerySchema';

export const toUserFilter = usersQuery.compile;
